/**
 * GiftCardsKpiRow — Total cards / Total issued / Outstanding balance
 * (BON-223), above the list. Mirrors the existing `KpiStrip` primitive's
 * `nb-kpi-strip`/`nb-kpi-cell` markup and classes rather than inventing a new
 * stat-tile look — the one addition is the responsive column count `KpiStrip`
 * doesn't have, since this row (unlike its desktop-only bookings/review
 * callers) has to stack on a phone-width list.
 *
 * Values come straight from the API's `summary`, which aggregates over the
 * CURRENT filter — never a client-side sum of the page's rows, which would
 * silently be wrong the moment there's more than one page.
 */
import { formatMoney } from '../review/reviewQueueModel';

import type { GiftCardSummary } from './giftCardTypes';

interface KpiCell {
  label: string;
  value: string;
}

export function GiftCardsKpiRow({
  summary,
  isPhone,
}: {
  summary: GiftCardSummary;
  isPhone: boolean;
}) {
  const cells: KpiCell[] = [
    { label: 'Total cards', value: summary.totalCards.toLocaleString() },
    { label: 'Total issued', value: formatMoney(summary.totalIssuedCents, 'usd') },
    { label: 'Outstanding balance', value: formatMoney(summary.totalBalanceCents, 'usd') },
  ];
  return (
    <div
      className="nb-kpi-strip"
      style={{ gridTemplateColumns: isPhone ? '1fr' : `repeat(${cells.length}, 1fr)` }}
    >
      {cells.map((cell) => (
        <div key={cell.label} className="nb-kpi-cell">
          <div className="nb-eyebrow" style={{ fontSize: 10 }}>
            {cell.label}
          </div>
          <div
            className="nb-tabular"
            style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em', marginTop: 4 }}
          >
            {cell.value}
          </div>
        </div>
      ))}
    </div>
  );
}
